/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_OfferInputs */

const en_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View offer`)
};

const ar_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطّلع على العرض`)
};

const de_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot ansehen`)
};

const es_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta`)
};

const fr_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l’offre`)
};

const it_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi l’offerta`)
};

const ja_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特典を見る`)
};

const ko_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`혜택 보기`)
};

const pt_br_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta`)
};

const ru_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть предложение`)
};

const th_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูข้อเสนอ`)
};

const tr_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifi gör`)
};

const zh_cn_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看优惠`)
};

const zh_tw_view_offer = /** @type {(inputs: View_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看優惠`)
};

/**
* | output |
* | --- |
* | "View offer" |
*
* @param {View_OfferInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const view_offer = /** @type {((inputs?: View_OfferInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_OfferInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_offer(inputs)
	if (locale === "ar") return ar_view_offer(inputs)
	if (locale === "de") return de_view_offer(inputs)
	if (locale === "es") return es_view_offer(inputs)
	if (locale === "fr") return fr_view_offer(inputs)
	if (locale === "it") return it_view_offer(inputs)
	if (locale === "ja") return ja_view_offer(inputs)
	if (locale === "ko") return ko_view_offer(inputs)
	if (locale === "pt_br") return pt_br_view_offer(inputs)
	if (locale === "ru") return ru_view_offer(inputs)
	if (locale === "th") return th_view_offer(inputs)
	if (locale === "tr") return tr_view_offer(inputs)
	if (locale === "zh_cn") return zh_cn_view_offer(inputs)
	return zh_tw_view_offer(inputs)
});